import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';

const DashboardLayout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const toggleSidebarCollapse = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  // Close mobile sidebar when screen size changes
  useEffect(() => {
    const handleResize = () => {
      // For tablets (768px and above), keep sidebar open by default
      if (window.innerWidth >= 1024) {
        setSidebarOpen(false);
      } else if (window.innerWidth >= 768) {
        // For tablets, auto-open sidebar
        setSidebarOpen(true);
      }
    };

    // Set initial state based on screen size
    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="flex h-screen bg-gradient-to-br from-gray-50 via-white to-blue-50/30 overflow-hidden">
      <Sidebar
        isOpen={sidebarOpen}
        onToggle={toggleSidebar}
      />

      <div className="flex-1 flex flex-col overflow-hidden transition-all duration-300 ease-in-out">
        <Header onMenuClick={toggleSidebar} />

        <main className="flex-1 overflow-auto">
          <div className="p-2 sm:p-3 md:p-4 lg:p-6 xl:p-8">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;